import React from 'react';

// Libraries
import MarkdownRenderer from 'markdown-to-jsx';

// Types
import Locale from '@/types/locale';
import RiskProfileItem from '@/types/risk-profile-item';
import { Profile as PartialOmniRiskProfileConfig } from '@/types/risk-profiles/omni/full-omni-risk-profile';

// Component Library
import { Inline } from '@capintel/component-lib/inline';
import { Pill } from '@capintel/component-lib/pill';

// Utils
import { formatMessage, formatLocalizedString } from '@/utils/i18n';

interface Props {
  data: {
    riskProfile: PartialOmniRiskProfileConfig | RiskProfileItem;
    recommended?: boolean;
  };
  locale: Locale;
  i18nBasePath: string;
  options?: {
    hideScoreRange?: boolean;
  };
}

const RiskProfileDescription: React.FC<Props> = ({ data, locale, i18nBasePath, options }) => {
  const { riskProfile, recommended } = data;
  const { hideScoreRange = false } = options || {};
  const { scoreRange, description, title } = riskProfile;

  return (
    <div className="profile-description">
      <div className="profile-header">
        <Inline gap="100" align="center">
          <span className="profile-title">{formatLocalizedString(title, locale)}</span>

          {recommended && <Pill size="small">{formatMessage(`${i18nBasePath}.Recommended`)}</Pill>}

          {scoreRange && !hideScoreRange && (
            <Pill size="small">{formatMessage(`${i18nBasePath}.ScoreRange`, { min: String(scoreRange.min), max: String(scoreRange.max) })}</Pill>
          )}
        </Inline>
      </div>

      <div className="description-text">
        <MarkdownRenderer options={{ disableParsingRawHTML: true }}>{formatLocalizedString(description, locale)}</MarkdownRenderer>
      </div>
    </div>
  );
};

export default RiskProfileDescription;
